import {
  LayoutDashboard, Users, UserCog, Image as ImageIcon, CalendarDays, Settings,
  MessageCircle, Facebook, Instagram, Linkedin, Youtube, Twitter, Pin, FileText,
  Package, Boxes, ReceiptText, FolderArchive, ShoppingCart, Wallet, Contact,
  ClipboardList, FileMinus2, ScrollText, Truck, Banknote, BarChart3, TrendingUp, Target,
} from "lucide-react";

export const PLATFORMS = [
  { key: "whatsapp", label: "WhatsApp Status", icon: MessageCircle, color: "#25D366" },
  { key: "facebook", label: "Facebook", icon: Facebook, color: "#1877F2" },
  { key: "instagram", label: "Instagram", icon: Instagram, color: "#E1306C" },
  { key: "linkedin", label: "LinkedIn", icon: Linkedin, color: "#0A66C2" },
  { key: "youtube", label: "YouTube", icon: Youtube, color: "#FF0000" },
  { key: "x", label: "X", icon: Twitter, color: "#111827" },
  { key: "pinterest", label: "Pinterest", icon: Pin, color: "#E60023" },
  { key: "blog", label: "Website Blog", icon: FileText, color: "#2A64F6" },
];

export function platformInfo(key) {
  return PLATFORMS.find((p) => p.key === key) || { key, label: key, icon: FileText, color: "#6B7280" };
}

export const STATUSES = ["Draft", "Scheduled", "Approved", "Posted"];

export const STATUS_STYLES = {
  Draft: "bg-amber-100 text-amber-700 border-amber-200",
  Scheduled: "bg-violet-100 text-violet-700 border-violet-200",
  Approved: "bg-blue-100 text-blue-700 border-blue-200",
  Posted: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const PERMISSIONS = [
  { key: "customers", label: "Customer add/edit" },
  { key: "team", label: "Team management" },
  { key: "social", label: "Social planner" },
  { key: "media", label: "Media upload" },
  { key: "approval", label: "Approval rights" },
  { key: "products", label: "Products & Inventory" },
  { key: "billing", label: "Billing & Accounts (invoices, sales)" },
  { key: "documents", label: "Documents — view only" },
  { key: "documents_download", label: "Documents — allow download" },
];

export const MEDIA_TYPES = ["picture", "video", "reel"];

export const UNITS = ["PCS", "BTL", "BOX", "BAG", "SET", "KG", "KGS", "GM", "LTR", "ML", "MTR", "DOZEN", "PAIR", "PACK", "NOS", "BUNDLE", "ROLL", "CAN", "JAR", "TUBE", "GROSS"];

export const INVOICE_STATUSES = ["Draft", "Issued", "Paid", "Cancelled"];

export const INVOICE_STATUS_STYLES = {
  Draft: "bg-amber-100 text-amber-700 border-amber-200",
  Issued: "bg-blue-100 text-blue-700 border-blue-200",
  Paid: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Cancelled: "bg-red-100 text-red-700 border-red-200",
};

export const PO_STATUSES = ["Draft", "Ordered", "Received", "Cancelled"];

export const PO_STATUS_STYLES = {
  Draft: "bg-amber-100 text-amber-700 border-amber-200",
  Ordered: "bg-blue-100 text-blue-700 border-blue-200",
  Received: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Cancelled: "bg-red-100 text-red-700 border-red-200",
};

export const EXPENSE_CATEGORIES = [
  "Rent", "Salaries & Wages", "Utilities", "Marketing & Advertising",
  "Travel & Conveyance", "Office Supplies", "Packaging", "Freight & Shipping",
  "Professional Fees", "Bank Charges", "Repairs & Maintenance",
  "Raw Material / Purchase", "GST Paid", "Miscellaneous",
];

export const PAYMENT_MODES = ["Cash", "Bank", "UPI", "Card", "Cheque"];

export const EXPENSE_STATUSES = ["Paid", "Unpaid"];

export const EXPENSE_STATUS_STYLES = {
  Paid: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Unpaid: "bg-amber-100 text-amber-700 border-amber-200",
};

export const PROFORMA_TYPES = ["Quotation", "Proforma"];

// Document types selectable when creating from the Quotations screen
// ("Tax Invoice" creates a real invoice rather than a proforma).
export const QUOTE_DOC_TYPES = ["Quotation", "Proforma", "Tax Invoice"];

export const PROFORMA_STATUSES = ["Draft", "Sent", "Accepted", "Converted", "Rejected", "Cancelled"];

export const PROFORMA_STATUS_STYLES = {
  Draft: "bg-gray-100 text-gray-600 border-gray-200",
  Sent: "bg-blue-100 text-blue-700 border-blue-200",
  Accepted: "bg-violet-100 text-violet-700 border-violet-200",
  Converted: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Rejected: "bg-red-100 text-red-700 border-red-200",
  Cancelled: "bg-red-100 text-red-700 border-red-200",
};

export const NOTE_TYPES = [
  { key: "credit", label: "Credit Note" },
  { key: "debit", label: "Debit Note" },
];

export const NOTE_REASONS = [
  "Sales Return", "Post-sale Discount", "Deficiency in Goods/Service",
  "Correction in Invoice", "Price Revision", "Others",
];

export const NOTE_STATUSES = ["Issued", "Settled", "Cancelled"];

export const NOTE_STATUS_STYLES = {
  Issued: "bg-blue-100 text-blue-700 border-blue-200",
  Settled: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Cancelled: "bg-red-100 text-red-700 border-red-200",
};

export const DC_TYPES = ["Supply on Approval", "Job Work", "Sales Return", "Line Sales", "Others"];
export const DC_STATUSES = ["Open", "Delivered", "Invoiced", "Cancelled"];
export const DC_STATUS_STYLES = {
  Open: "bg-blue-100 text-blue-700 border-blue-200",
  Delivered: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Invoiced: "bg-violet-100 text-violet-700 border-violet-200",
  Cancelled: "bg-red-100 text-red-700 border-red-200",
};

export const EWAY_DOC_TYPES = ["Tax Invoice", "Delivery Challan", "Bill of Supply"];
export const EWAY_STATUSES = ["Active", "Cancelled"];
export const EWAY_STATUS_STYLES = {
  Active: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Cancelled: "bg-red-100 text-red-700 border-red-200",
};
export const TRANSPORT_MODES = ["Road", "Rail", "Air", "Ship"];

export const PAYMENT_DIRECTIONS = [
  { key: "in", label: "Payment In (Receipt)" },
  { key: "out", label: "Payment Out (Paid)" },
];
export const PAYMENT_IN_STATUSES = ["Received", "Pending"];
export const PAYMENT_OUT_STATUSES = ["Paid", "Pending"];
export const PAYMENT_STATUS_STYLES = {
  Received: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Paid: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Pending: "bg-amber-100 text-amber-700 border-amber-200",
};

// GST state codes (place of supply / billing state)
export const INDIAN_STATES = [
  { code: "01", name: "Jammu & Kashmir" }, { code: "02", name: "Himachal Pradesh" },
  { code: "03", name: "Punjab" }, { code: "04", name: "Chandigarh" },
  { code: "05", name: "Uttarakhand" }, { code: "06", name: "Haryana" },
  { code: "07", name: "Delhi" }, { code: "08", name: "Rajasthan" },
  { code: "09", name: "Uttar Pradesh" }, { code: "10", name: "Bihar" },
  { code: "11", name: "Sikkim" }, { code: "12", name: "Arunachal Pradesh" },
  { code: "13", name: "Nagaland" }, { code: "14", name: "Manipur" },
  { code: "15", name: "Mizoram" }, { code: "16", name: "Tripura" },
  { code: "17", name: "Meghalaya" }, { code: "18", name: "Assam" },
  { code: "19", name: "West Bengal" }, { code: "20", name: "Jharkhand" },
  { code: "21", name: "Odisha" }, { code: "22", name: "Chhattisgarh" },
  { code: "23", name: "Madhya Pradesh" }, { code: "24", name: "Gujarat" },
  { code: "26", name: "Dadra & Nagar Haveli and Daman & Diu" },
  { code: "27", name: "Maharashtra" }, { code: "29", name: "Karnataka" },
  { code: "30", name: "Goa" }, { code: "31", name: "Lakshadweep" },
  { code: "32", name: "Kerala" }, { code: "33", name: "Tamil Nadu" },
  { code: "34", name: "Puducherry" }, { code: "35", name: "Andaman & Nicobar Islands" },
  { code: "36", name: "Telangana" }, { code: "37", name: "Andhra Pradesh" },
  { code: "38", name: "Ladakh" },
];

export const GST_RATES = [0, 3, 5, 12, 18, 28];

export const LEAD_STAGES = ["New", "Contacted", "Qualified", "Sample Sent", "Proposal", "Won", "Lost", "Lead"];
export const CUSTOMER_STATUSES = ["New", "Contacted", "Qualified", "Sample Sent", "Proposal", "Won", "Lost", "Lead", "Active", "Inactive"];
export const LEAD_STATUS_STYLES = {
  New: "bg-blue-100 text-blue-700 border-blue-200",
  Contacted: "bg-indigo-100 text-indigo-700 border-indigo-200",
  Qualified: "bg-violet-100 text-violet-700 border-violet-200",
  "Sample Sent": "bg-pink-100 text-pink-700 border-pink-200",
  Proposal: "bg-amber-100 text-amber-700 border-amber-200",
  Won: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Lost: "bg-red-100 text-red-700 border-red-200",
  Lead: "bg-gray-100 text-gray-600 border-gray-200",
  Active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Inactive: "bg-gray-100 text-gray-500 border-gray-200",
};

export const TONES = ["friendly", "luxurious", "playful", "professional", "festive", "minimal", "bold"];

export const PLATFORM_LIMITS = {
  whatsapp: 700, facebook: 63206, instagram: 2200, linkedin: 3000,
  youtube: 5000, x: 280, pinterest: 500, blog: 100000,
};

export const PLATFORM_TIPS = {
  whatsapp: "Keep it short & punchy — status views are quick.",
  facebook: "Conversational; ask a question to lift engagement.",
  instagram: "Strong first-line hook; up to 30 hashtags work well.",
  linkedin: "Professional tone; lead with value; 3-5 hashtags.",
  youtube: "Front-load keywords; add links & timestamps.",
  x: "280 characters max; keep to 1-2 hashtags.",
  pinterest: "Keyword-rich; describe the visual & the benefit.",
  blog: "SEO-friendly title + intro; long-form is fine.",
};

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const ICONS = {
  LayoutDashboard, Users, UserCog, ImageIcon, CalendarDays, Settings,
  Package, Boxes, ReceiptText, FolderArchive, ShoppingCart, Wallet, Contact,
  ClipboardList, FileMinus2, ScrollText, Truck, Banknote, BarChart3,
  TrendingUp, Target,
};

export const DOC_CATEGORIES = [
  { key: "ledger", label: "Ledger" },
  { key: "annual_report", label: "Annual Report" },
  { key: "purchase_order", label: "Purchase Order" },
  { key: "expenses", label: "Expenses" },
  { key: "company_credentials", label: "Company Credentials" },
  { key: "reports", label: "Reports" },
  { key: "payments", label: "Payments (Made/Received)" },
  { key: "delivery_challan", label: "Delivery Challans" },
  { key: "other", label: "Other" },
];
export const LOGO_URL = "https://img1.wsimg.com/isteam/ip/022d8710-7476-4474-b2d6-852e4b895933/Company%20LOGO.jpg";
